import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'react-bootstrap';

import { Shapes } from '../../models/entities';

const TerminalCredentialsModal = (props) => {
  const {
    onHide, show, terminal,
  } = props;

  return (
    <Modal show={show} size="lg" onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <strong>
            Terminal&nbsp;&apos;
            {terminal ? terminal.name : '-'}
            &apos;&nbsp;Credentials
          </strong>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>
          <strong>IMPORTANT:</strong>
          The following OAuth 2.0 credentials were generated for the BPT
          &apos;
          {terminal ? terminal.name : '-'}
          &apos;.&nbsp;
          <strong>This information won&apos;t be available again</strong>
          , so make sure you store it (securely) somewhere.
        </p>
        <br />
        <p>
          <strong>Client ID:&nbsp;</strong>
          {terminal ? terminal.oauth2ClientId : '-'}
          <br />
          <strong>Client Secret:&nbsp;</strong>
          {terminal ? terminal.oauth2ClientSecret : '-'}
        </p>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

TerminalCredentialsModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func.isRequired,
  terminal: Shapes.TERMINAL,
};

TerminalCredentialsModal.defaultProps = {
  show: false,
  terminal: undefined,
};

export default TerminalCredentialsModal;
